import { render, staticRenderFns } from "./BottomHeaderComponent.vue?vue&type=template&id=36609a70&lang=pug&"
import script from "./BottomHeaderComponent.vue?vue&type=script&lang=js&"
export * from "./BottomHeaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports